import { DatePipe } from "@angular/common";
import { Component, ElementRef, Inject, OnInit, Optional, ViewChild } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { AuthService } from "app/auth/auth.service";
import { AddServiceComponent } from "app/billing/add-service/add-service.component";
import { BillingserviceService } from "app/billing/billingService.service";
import { DashboardService } from "app/dashboard/dashboard.service";
import { IPDService } from "app/ipd/Services/ipdServices.service";
import { OpdVisitService } from "app/opdvisits/Services/OpdVisit.service";
import * as moment from "moment";
import { Observable, Subject, Subscription, fromEvent, interval } from "rxjs";
import {
  exhaustMap,
  map,
  startWith,
  take,
  takeUntil,
  tap,
} from "rxjs/operators";
import { HelpListPopupComponent } from "../Doctor/doctor-other-info/help-list-popup/help-list-popup.component";
import { SurgeryModel } from "../DoctorModels/surgery.model";
import { EMRService } from "../EMR.service";
import { SurgicalHistoryModel } from "../HistoryModels/surgicalhistory.model";
import { CounselorService } from "./counselor.service";
import { PackageSelectionComponent } from "./package-selection/package-selection.component";
import { ShowExaminationComponent } from "./show-examination/show-examination.component";
import { HelplistService } from "app/helplist.service";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { OtherSurgeryPopupComponent } from "../other-surgery-popup/other-surgery-popup.component";
import { OTConsentComponent } from "app/ipd/otconsent/otconsent.component";
import { BranchMatserService } from "app/masters/branch-matser.service";
import { CorporateDetailComponent } from "app/billing/corporate-detail/corporate-detail.component";
import { PreopDetailComponent } from "app/ipd/preop-detail/preop-detail.component";
import { IOLComponent } from "./iol/iol.component";
import { PreAnaeQuestionComponent } from "app/ipd/pre-anae-question/pre-anae-question.component";
import { DynamicHelpListComponent } from "../Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component";

@Component({
  selector: "app-Counselor",
  templateUrl: "./Counselor.component.html",
  styleUrls: ["./Counselor.component.scss"],
})
export class CounselorComponent implements OnInit {
  destroycounselor$: Subject<boolean> = new Subject<boolean>();
 private surgery_data: MatTableDataSource<SurgeryModel>;
 private displayedColumns_surgery: string[] = ["surgery", "site", "surgeon"];
 private displayedColumns_surgerybk: string[] = [
    "surgery",
    "site",
    "surgeon",
    "Action",
  ];
  private getOPTypeArray: any = [];
  private OpTypeCtrl = new FormControl();
  private filteredOpTypeArray: Observable<any[]>;
  private OTTheatreCtrl = new FormControl();
  private filteredOTTheatreArray: Observable<any[]>;
  private branchCtrl = new FormControl();
  private filteredbranchArray: Observable<any[]>;
  private  DoctorCtrl = new FormControl();
  private filteredDoctorArray: Observable<any[]>;
  private DoctorCtrl2 = new FormControl();
  private filteredDoctor2Array: Observable<any[]>;
  private AsstDoctorCtrl = new FormControl();
  private filteredAsstDoctorArray: Observable<any[]>;
  private AnaeDoctorCtrl = new FormControl();
  private filteredAnaeDoctorArray: Observable<any[]>;
  private PartyCtrl = new FormControl();
  private  filteredPartyArray: Observable<any[]>;
  private  opTypeName: any;
  private  opTypeId: any;
  private rateTypelist: any;
  private labStatus: any;
  private counselorname: any;
  private WardListArray: any;
  private anesthtype: any;
  private  getOtTheatreArray: any = [];
  private OTTheatreName: any;
  private OTTheatreId: any;
  private casetype: any;
  private  SurgeryStatus: any;
  private  appservice: any;
  private  DoctorListArray: any;
  private surgeryStatusArray: any;
  private partynameArray: any = [];
    drRemarks: string='';
  private  drName: any;
  private  cnsRemarks: any;
  private  surgerylist: any;
  private  surgeryMainArray: any = [];
  private booksurgery_ds: MatTableDataSource<SurgicalHistoryModel>;
  private packagedetailslist: any;
  private  getRateTypeVal: any;
  private  PackageListArray: any = [];
  private  allPackageList: any;
  private  totalAmount: number;
  private  totalupgradedAmount: number;
  private totaldiscount: any = 0;
  private stotalAmount: number = 0;
  private stotaldiscount: number = 0;
  private totaldifferenceAmount: number;
  private BookingDate: string;
  private mainSurgeronName: string;
  private coSurgeronName: any;
  private asstSurgeronName: any;
  private  nxtdate: boolean = true;
  private postdisdate: boolean = true;
  private cancelDateDisabled: boolean = true;
  private AnaeListArray: any;
  destroy$: Observable<any>;
  private checktpa: number = 0;
  private bookbyname: string;
  private AddServiceArray: any = [];
  private counTrackinglist: any;
  private aneastheticname: any;
  private  surgicalchk: any;
  private  anerTypeList: any;
  private showPartyName: any;
  private totalGAmount: number;
  private esttotalAmount: number = 0;
  private totalSAmount: number = 0;
  private  totalSDAmount: number;
  private  totalSPAmount: number;
  private  totalPAmount: number;
  private totalDAmount: number;
  private serviceOrder_ds: MatTableDataSource<any>;
  private totalSdiscount: any = 0;
  private finalDiscountAmount: any = 0;
  private MinimeDate: string;
  private regid: number;
  private disCancel: boolean = true;
  private  disPost: boolean = true;
  private  userId: number;
  private  modifiedName: string;
  private  bookstatus: any;
  private timeFormatcheck: any;
  private lblname: string;
  private getExamid: any;
  private removeService: any = [];
  private removePackagedetail: any = [];
  private selectedSugeryArray: any = [];
  private  helplistsergery: any = [];
  private eyetype: string;
  private disablesitel: boolean = true;
  private disablesiter: boolean = true;
  private disablesiteb: boolean = true;
  private disablesiten: boolean = false;
  @ViewChild('SurgeronNameauto', { static: false }) private SurgeronNameautoRef: ElementRef;
   @ViewChild('opTypeNameauto', { static: false }) private opTypeNameautoRef: ElementRef;
   @ViewChild('eyenameauto', { static: false }) private eyeNameautoRef: ElementRef;
   @ViewChild('PartyNameauto', { static: false }) private PartyNameautoRef: ElementRef;
   @ViewChild('bookingauto', { static: false }) private bookingautoRef: ElementRef;
   @ViewChild('caseauto', { static: false }) private caseautoRef: ElementRef;
   @ViewChild('ratetypeauto', { static: false }) private rateTypeautoRef: ElementRef;
   @ViewChild('aneatypeauto', { static: false }) private aneatypeautoRef: ElementRef;
  constructor(
    private dialog: MatDialog,
    private branchMatserService: BranchMatserService,
    private ipdService: IPDService,
    private emrService: EMRService,
    private dashboardService: DashboardService,
    private opdvisitService: OpdVisitService,
    private counselorService: CounselorService,
    private authservice: AuthService,
    private billingservice: BillingserviceService,
    private datePipe: DatePipe,
    private helplistservice: HelplistService,
    private dialogRef: MatDialogRef<CounselorComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    dialogRef.disableClose = true;
  }
  checkdisable(type2) {
    if (type2 == 1) {
      this.eyetype = "LE";
      this.disablesitel = false;
      this.disablesiter = true;
      this.disablesiteb = true;
      this.disablesiten = true;
    } else if (type2 == 2) {
      this.eyetype = "RE";
      this.disablesitel = true;
      this.disablesiter = false;
      this.disablesiteb = true;
      this.disablesiten = true;
    } else if (type2 == 3) {
      this.eyetype = "BE";
      this.disablesitel = true;
      this.disablesiter = true;
      this.disablesiteb = false;
      this.disablesiten = true;
    } else if (type2 == 4) {
      this.eyetype = "None";
      this.disablesitel = true;
      this.disablesiter = true;
      this.disablesiteb = true;
      this.disablesiten = false;
    }
  }

  disabledreceptbutton: boolean = false;
  ngAfterViewInit(): void {
    fromEvent(this.button.nativeElement, "click")
      .pipe(
        tap((x) => (this.disabledreceptbutton = true)),
        exhaustMap((ev) => {
          return this.createUser();
        })
      )
      .subscribe(this.handleResponse());
  }
  @ViewChild("CounclerCreateBtn", { static: true }) button;
  clicks$: Observable<any>;
  createUser(): Observable<any> {
    return interval(500).pipe(take(1));
  }
  handleResponse(): any {
    return {
      next: (res) => {
        this.saveCouselor();
      },
      error: (err) => {},
    };
  }
  ngOnInit() {
 
    this.regid = this.opdvisitService.patientdetails.pkRegId;
    this.AddServiceArray=[];
    this.ipdService.share.pipe(takeUntil(this.destroycounselor$)).subscribe((item) => {
  
  if(item !=null){

    if (Object.keys(item).length != 0) {
      this.regid = item["fK_RegId"];
      this.getCounselorId(this.regid);
      this.getBranchDetail(this.authservice.Loggeduser.branchid);
      this.getemrpermissioncheck();
    }
   }
    });
    this.timeFormatcheck = "AM";
    this.emrService.counselorExamModel = {};
    this.MinimeDate = moment(new Date(this.authservice.getServerDate)).format(
      "YYYY-MM-DD"
    );
  
    this.counselorname = this.authservice.Loggeduser.username;
    // this.GetSurgeryDetailByRegId(this.regid,0,0);
    this.drRemarks='';
    this.GetotTypeData();
    this.rateType();
    this.getwardlist();
    this.GetOtTheatreData();
    this.getAlluser();
    this.getsurgeryStatus();
    this.getPartyname();
    this.OpTypeControll();
    this.branchControll();
    this.getRateTypeVal = "RateGeneral";
    this.totalAmount = 0;
    this.totalupgradedAmount = 0;
    this.totaldifferenceAmount = 0;
    this.getAllPackageList();
    this.counselorNo();
    this.getAnaePopup();
    this.emrService.content.pipe(takeUntil(this.destroycounselor$)).subscribe((x: any) => {
      if (x == 3) {
        this.getCounselorId(this.regid);
      }
    });
    
    if (this.data.Patientid) {
      this.emrService.visitid =this.data.visitid;
      this.getCounselorId(this.data.Patientid);
      this.getBranchDetail(this.authservice.Loggeduser.branchid);
      this.getemrpermissioncheck();
    } else {
      this.getCounselorId(this.regid);
    }
    
    this.removeService = [];
    this.removePackagedetail = [];
    this.emrService.counselorExamModel.surgeryTime = moment(
      JSON.parse(sessionStorage.getItem('SessiondateTime'))
    ).format("h:mm A");
    this.emrService.counselorExamModel.reportingTime = moment(
      JSON.parse(sessionStorage.getItem('SessiondateTime'))
    ).format("h:mm A");
    this.helplistsergery = [];
    this.helplistsergery = this.helplistservice.surgeryList.filter(
      (item) => item.isActive == true
    );
    this.eyetype = "None";

  }
   getemrpermissioncheck(){
    this.emrService
    .getemrPermissionuserid()
    .pipe(takeUntil(this.destroycounselor$))
    .subscribe(
      (x: any) => {
        if (x.length > 0) {
         
          this.emrService.counselorPermission=  x.filter(item=>item.menuDetailName=='mnuCounselor')[0];
        }
      },err =>{
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      })
   }
  getBranchDetail(id) {
    this.emrService.branchmansterObj = {};
     this.branchMatserService.getBrachMasterItem(id).pipe(takeUntil(this.destroycounselor$)).subscribe((x: any) => {
      this.emrService.branchmansterObj = x[0];
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  getCounselorId(regid) {
     this.counselorService.getCounsVisit(regid).pipe(takeUntil(this.destroycounselor$)).subscribe((data) => {
      var counsVisitlist =[];
      if(!this.emrService.visitid){
         counsVisitlist = data
      }else{
         counsVisitlist = data.filter(
          (item) => item.pK_VisitId == this.emrService.visitid
        );
      }
     
      let cid = counsVisitlist[0]?.pK_CounselorId;
      if (counsVisitlist.length != 0 && cid != null) {
        this.counselorService.getCounselorById(cid).pipe(takeUntil(this.destroycounselor$)).subscribe(
          (data) => this.success_counselordetails(data),
          (err) => this.failed_details(err)
        );
        this.packageDetails(cid);
        this.surgeryDetails(cid);
        this.additionalServiceDetails(cid);
        this.countrackinDetails(cid);
      } else {
        // this.selectedCounselorId = this.opdvisitService.opdvisit_list.filter(
        //   (item) => item.fK_RegID == this.regid
        // );
        this.emrService.counselorExamModel.pK_CounselorId = 0;
        this.emrService.counselorExamModel.isSurgical = true;
        this.emrService.counselorExamModel.fK_VisitId = counsVisitlist[0]?.pK_VisitId;
        this.emrService.counselorExamModel.surgeryDate =
          this.dashboardService.selecteddate;
        this.emrService.counselorExamModel.reportingDate =
          this.dashboardService.selecteddate;
        this.emrService.counselorExamModel.rateType = 1;
        this.emrService.counselorExamModel.fK_PartyId = 1;
        if (this.partynameArray.length > 0) {
          let partyid = this.partynameArray.filter(
            (partyitem) =>
              partyitem.pkPartyId == this.partynameArray[0].pkPartyId
          )[0];
          this.showPartyName = partyid.partyName;
          this.getRateList(partyid.pkPartyId);
        } else {
          this.showPartyName = "";
          this.getRateList(1);
        }

        this.emrService.counselorExamModel.fK_ForBranchId =
          this.authservice.Loggeduser.branchid;
        this.emrService.counselorExamModel.branchName =
          this.authservice.Loggeduser.branchname;
        this.emrService.counselorExamModel.fK_StatusId = 1;
        this.emrService.counselorExamModel.fK_ExamId = this.emrService.examid;
        this.emrService.counselorExamModel.eye = "";
      }
    },err=>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }

  getAnaePopup() {
   this.counselorService.getAnarType().pipe(takeUntil(this.destroycounselor$)).subscribe((data) => {
      let filterary = data;
      this.anerTypeList = filterary.filter((item) => item.isActive == true);
    },err=>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }

  success_counselordetails(data) {
    this.esttotalAmount = null;
    this.finalDiscountAmount = null;
    this.emrService.counselorExamModel = data;
    this.emrService.counselorExamModel.bookingDate = this.datePipe.transform(
      data.bookingDate,
      "yyyy-MM-dd"
    );
    this.emrService.counselorExamModel.surgeryDate = this.datePipe.transform(
      data.surgeryDate,
      "yyyy-MM-dd"
    );
    this.emrService.counselorExamModel.reportingDate = this.datePipe.transform(
      data.reportingDate,
      "yyyy-MM-dd"
    );
    this.emrService.counselorExamModel.nextFollowupDate =
      this.datePipe.transform(data.nextFollowupDate, "yyyy-MM-dd");
      if(this.emrService.counselorExamModel.nextFollowupDate){
        this.nxtdate =false;
      }
    if (data.cancel_Date != null) {
      this.disCancel = false;
      this.cancelDateDisabled = false;
    } else {
      this.disCancel = true;
      this.cancelDateDisabled = false;
    }
    if (data.postponed_Date != null) {
      this.disPost = false;
      this.postdisdate = false;
    } else {
      this.disPost = true;
      this.postdisdate = true;
    }
    this.emrService.counselorExamModel.cancel_Date = this.datePipe.transform(
      data.cancel_Date,
      "yyyy-MM-dd"
    );
    this.emrService.counselorExamModel.postponed_Date = this.datePipe.transform(
      data.postponed_Date,
      "yyyy-MM-dd"
    );
    this.emrService.counselorExamModel.cancel_Reason = data.cancel_Reason;
    this.emrService.counselorExamModel.postponed_Reason = data.postponed_Reason;
    let filterDctname = this.DoctorListArray.filter(
      (item) => item.pkUserId == data.fK_MainSurgeronId
    );
    this.mainSurgeronName = filterDctname[0]?.userName;
    let codctname = this.DoctorListArray.filter(
      (item) => item.pkUserId == data.fK_CoSurgeronId
    );
    this.coSurgeronName = codctname[0]?.userName;
    let asstname = this.DoctorListArray.filter(
      (item) => item.pkUserId == data.fK_AssistantSurgeonId
    );
    this.asstSurgeronName = asstname[0]?.userName;
    let anaename = this.AnaeListArray.filter(
      (item) => item.pkUserId == data.fK_AneastheticId
    );
    this.aneastheticname = anaename[0]?.userName;
    let theatre = this.getOtTheatreArray.filter(
      (item) => item.pK_OTTheatreId == data.fK_TheatreId
    );
    this.OTTheatreName = theatre[0]?.theatreName;
    let optype = this.getOPTypeArray.filter(
      (item) => item.pK_OperationTypeId == data.fK_OperationTypeId
    );
    this.opTypeName = optype[0]?.operationTypeName;
    let anetype = this.anerTypeList.filter(
      (item) => item.pkPopupId == data.fK_AnesthTypeId
    );
    this.anesthtype = anetype[0]?.popupDescription;
    let bookbyid = this.authservice.users.filter(
      (item) => item.pkUserId == data.fK_BookedById
    );
    this.bookbyname = bookbyid[0]?.userName;
    let partyid = this.partynameArray.filter(
      (item) => item.pkPartyId == data.fK_PartyId
    );
    this.showPartyName = partyid[0]?.partyName;
    this.emrService.counselorExamModel.remarks = data.remarks;
    this.emrService.counselorExamModel.discount = data.discount;
    this.emrService.counselorExamModel.netEstimate = data.netEstimate;
    this.esttotalAmount = data.totalSurgeryAmount;
    this.finalDiscountAmount = data.discount;
    this.totaldiscount = data.discount;
    this.emrService.counselorExamModel.totalSurgeryAmount = this.esttotalAmount;
    this.emrService.counselorExamModel.discount = this.finalDiscountAmount;
    this.emrService.counselorExamModel.reportingTime =
      data.reportingTime != null
        ? moment(data.reportingTime).format("h:mm A")
        : null;
    this.emrService.counselorExamModel.surgeryTime =
      data.surgeryTime != null
        ? moment(data.surgeryTime).format("h:mm A")
        : null;
    this.getRateList(data.fK_PartyId);
    let modifiedid = this.authservice.users.filter(
      (item) => item.pkUserId == data.fK_ModifiedById
    );
    this.modifiedName = modifiedid[0]?.userName;
    this.emrService.counselorExamModel.counselorNo =
      data.counselorNo != null ? data.counselorNo : this.userId;
    this.emrService.counselorExamModel.fK_ForBranchId =
      data.fK_ForBranchId != null
        ? data.fK_ForBranchId
        : this.emrService.counselorExamModel.fK_ForBranchId;
    this.drName = data.advisedBy;
    // this.surgery_data = this.surgerylist.filter(sitem => sitem.fK_ExamId == data.fK_ExamId);
    if (data.fK_ExamId != null) {
      this.getExamid = data.fK_ExamId;
      this.GetSurgeryDetailByRegId(this.regid, 0, 0);
      this.GetFindingGResultByregid(this.regid,data.fK_VisitId);
      
    }
    if (data.fK_StatusId != null) {
      this.surgeryStatus(data.fK_StatusId);
    }
  }
  GetFindingGResultByregid(regid ,visitid){
   
    this.emrService.GetFindingGResultByregid(regid,visitid,this.opdvisitService.DoctorIdEmr).pipe(takeUntil(this.destroycounselor$)).subscribe((x:any)=>{
      let drReview = x.filter(
        (item) => item.pK_ExamId == this.getExamid
      )[0];
      this.cnsRemarks = drReview?.remarksForCounselor;
      this.drRemarks = drReview?.drRemarks ?drReview?.drRemarks:'';
   },err=>{
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
   })
 }
  failed_details(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  GetSurgeryDetailByRegId(regid, visit, docid) {
   this.emrService
      .GetSurgeryDetailByRegId(regid, visit, docid).pipe(takeUntil(this.destroycounselor$))
      .subscribe((data) => {
        this.surgerylist = data;
        
        if (this.getExamid != 0) {
          this.surgery_data = this.surgerylist.filter(
            (sitem) => sitem.fK_ExamId == this.getExamid
          );
        }
      },err=>{
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }

  packageDetails(id) {
    this.counselorService.getpackageById(id).pipe(takeUntil(this.destroycounselor$)).subscribe((data) => {
    
      this.PackageListArray = data;
      this.paymentDetail(this.PackageListArray);
    },err=>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }

  surgeryDetails(id) {
    this.surgeryMainArray = [];
    this.counselorService.getSurgeryById(id).pipe(takeUntil(this.destroycounselor$)).subscribe((data) => {
      this.booksurgery_ds = data;
      this.surgeryMainArray = this.booksurgery_ds;
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }

  additionalServiceDetails(id) {
   this.counselorService
      .GetCounselorAdditionalService(id).pipe(takeUntil(this.destroycounselor$))
      .subscribe((data) => {
        this.AddServiceArray = data;
        this.servicepaymentDetail();
      },err=>{
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }

  serviceRemoveRow(index, event) {
    let selectPkid = event.pK_TranId;
    if (selectPkid != 0) {
      this.removeService.push(event);
    }
    this.AddServiceArray.splice(index, 1);
    this.servicepaymentDetail();
    this.paymentDetail(this.PackageListArray);
  }

  countrackinDetails(id) {
    this.counselorService.getTrackingdetails(id).pipe(takeUntil(this.destroycounselor$)).subscribe((data) => {
      this.counTrackinglist = [];
      this.counTrackinglist = data;
    },err=>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }

  serchdoctor(doctorid) {
    let doctorname = this.opdvisitService.doctors.filter(
      (item) => item.userId == doctorid
    );
    if (doctorname.length > 0) {
      return doctorname[0].userName;
    } else {
      return null;
    }
  }
  serchdoctorName(SurgeonName) {
    let doctorname = this.opdvisitService.doctors.filter(
      (item) => item.userName == SurgeonName
    );
    if (doctorname.length > 0) {
      return doctorname[0].userId;
    } else {
      return null;
    }
  }
  mainSurgeonValidation(event: any) {
    let value = event.target.value;
    if (value == "") {
      this.mainSurgeronName = "";
    }
  }
  /** Show Examination */
  modalShowExamination() {
    this.GetSurgeryDetailByRegId(this.regid, 0, 0);
    const dialogRef = this.dialog.open(ShowExaminationComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "500px",
      width: "80%",
      disableClose: true,
    });

     dialogRef.afterClosed().pipe(takeUntil(this.destroycounselor$)).subscribe((result) => {
      if (result != null) {
        this.drName = result.drName;
        this.mainSurgeronName = result.drName;
        this.cnsRemarks = result.remarksForCounselor;
        this.drRemarks = result.drRemarks?result.drRemarks:'';
        this.surgery_data = this.surgerylist.filter(
          (item) => item.fK_ExamId == result.pK_ExamId
        );
        this.emrService.counselorExamModel.fK_AdvicedById = result.fK_DoctorId;
        this.emrService.counselorExamModel.fK_MainSurgeronId =
          result.fK_DoctorId;
        this.emrService.counselorExamModel.fK_AdvicedById = result.fK_DoctorId;
        this.emrService.counselorExamModel.fK_ExamId = result.pK_ExamId;
        this.emrService.counselorExamModel.fK_VisitId = result.fK_VisitId;
      }
    },err=>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  /** Package Selection */
  modalPackageSelection() {
    if (this.checktpa == 0) {
      return this.dashboardService.openSnackBar(
        "Please Select Payor Name",
        "OK"
      );
    }
    this.ipdService.selectedServiceRow = [];
    const dialogRef = this.dialog.open(PackageSelectionComponent, {
      // panelClass: "full-width-dialog",
      maxWidth: "90vw !important",
      // height: "500px",
      width: "80%",
      disableClose: true,
      data: {
        id: this.emrService.counselorExamModel.fK_PartyId,
        Type: this.getRateTypeVal,
      },
    });

   dialogRef.afterClosed().pipe(takeUntil(this.destroycounselor$)).subscribe((result) => {
      result = this.ipdService.selectedServiceRow;

      result?.forEach((element) => {
        this.PackageListArray.push({
          pK_TranId: 0,
          fK_CounselorId: this.emrService.counselorExamModel.pK_CounselorId,
          fK_PackageId: element.pK_PackageId,
          discountPer: null,
          amount: element.packageAmount,
          packageName: element.packageName,
          packageType: element.packageType,
          IsEdit: false,
          IsDelete: false,
        });
      });

      this.PackageListArray = this.PackageListArray?.reduce((unique, o) => {
        if (
          !unique.some(
            (obj) =>
              obj.packageName === o.packageName &&
              obj.packageAmount === o.packageAmount
          )
        ) {
          unique.push(o);
        }
        return unique;
      }, []);

      console.log("selected service", this.PackageListArray);
      this.paymentDetail(this.PackageListArray);
    });
  }

  selectedNormalPackage(value: number, index: number) {
    var obj: any;
    for (let i = 0; i < this.allPackageList.length; i++) {
      if (this.allPackageList[i].pK_PackageId == value) {
        obj = this.allPackageList[i];
      }
    }
    this.PackageListArray[index].packageName = obj.packageName;
    this.PackageListArray[index].amount = obj.packageAmount;
    this.PackageListArray[index].fK_PackageId = obj.pK_PackageId;
    this.paymentDetail(this.PackageListArray);
  }

  paymentDetail(data) {
    this.totalupgradedAmount = 0;
    if (this.emrService.counselorExamModel.pK_CounselorId === 0) {
      this.totalAmount = 0;
      this.totaldiscount = 0;
      data?.forEach((element) => {
        if (element.amount) {
          this.totalAmount = this.totalAmount + parseInt(element.amount);
          if (element.discountPer > 0) {
            const discountAmount =
              (parseInt(element.amount) * parseInt(element.discountPer)) / 100;
            this.totaldiscount =
              parseInt(this.totaldiscount) +
              this.stotaldiscount +
              parseInt(discountAmount.toFixed(2));
          }
        } else if (element.amount) {
          this.totalAmount =
            this.totalAmount + this.stotalAmount + parseInt(element.amount);
          if (element.discountPer > 0) {
            const discountAmount =
              (parseInt(element.amount) * parseInt(element.discountPer)) / 100;
            this.totaldiscount =
              parseInt(this.totaldiscount) +
              parseInt(discountAmount.toFixed(2));
          }
        }
      });
      this.esttotalAmount =
        this.totalAmount + this.stotalAmount + this.totalSAmount;
      this.finalDiscountAmount =
        parseInt(this.totaldiscount) + this.totalSdiscount;
      this.emrService.counselorExamModel.discount = this.finalDiscountAmount;
      this.emrService.counselorExamModel.totalSurgeryAmount =
        this.esttotalAmount;
      this.emrService.counselorExamModel.netEstimate =
        this.esttotalAmount - this.finalDiscountAmount;

      // if (this.totaldifferenceAmount > this.totalAmount) {
      //   this.totalupgradedAmount = this.totaldifferenceAmount - this.totalAmount;
      // }
    } else if (this.emrService.counselorExamModel.pK_CounselorId > 0) {
      this.totalAmount = 0;
      this.totaldiscount = 0;
      this.PackageListArray?.forEach((element) => {
        this.totalAmount = this.totalAmount + parseInt(element.amount);
        if (element.discountPer > 0) {
          const discountAmount =
            (parseInt(element.amount) * parseInt(element.discountPer)) / 100;
          this.totaldiscount =
            parseInt(this.totaldiscount) + parseInt(discountAmount.toFixed(2));
        }
      });
      this.totalAmount = this.totalAmount + this.stotalAmount;
      this.totaldiscount = parseInt(this.totaldiscount) + this.stotaldiscount;
      this.totaldifferenceAmount = 0;
      // this.UpgradePackageListArray?.forEach(element => {
      //   this.totaldifferenceAmount = this.totaldifferenceAmount + parseInt(element.amount)
      // })
      if (this.totaldifferenceAmount > this.totalAmount) {
        this.totalupgradedAmount =
          this.totaldifferenceAmount - this.totalAmount;
      }
      this.esttotalAmount = this.totalAmount + this.totalSAmount;
      this.finalDiscountAmount = this.totaldiscount + this.totalSdiscount;
      this.emrService.counselorExamModel.discount = this.finalDiscountAmount;
      this.emrService.counselorExamModel.totalSurgeryAmount =
        this.esttotalAmount;
      this.emrService.counselorExamModel.netEstimate =
        this.esttotalAmount - this.finalDiscountAmount;
    }
  }

  onupdateDiscount(e: number, index: number) {
    if (e === null || e === undefined) {
      this.PackageListArray[index].discountPer = 0;
    } else {
      if (e >= 0 && e <= 100) {
        this.PackageListArray[index].discountPer = e;
        this.paymentDetail(this.PackageListArray);
      } else {
        this.PackageListArray[index].discountPer = 0;
        this.paymentDetail(this.PackageListArray);
        this.dashboardService.openSnackBar(
          "Please Enter Percentage 0 to 100 ",
          "OK"
        );
      }
    }
  }

  onupdateAmount(e: number, index: number) {
    if (e === null || e === undefined) {
    } else {
     // this.PackageListArray[index].discountPer = 0;
      this.PackageListArray[index].amount = e;
      this.paymentDetail(this.PackageListArray);
    }
  }

  removeRow(x, element) {
    if (element.pK_TranId != 0) {
      this.removePackagedetail.push(element);
    }
    this.PackageListArray.splice(x, 1);
    this.paymentDetail(this.PackageListArray);
    this.servicepaymentDetail();
    if (this.emrService.counselorExamModel.counselorNo > 0) {
     this.ipdService.deletePackage(element.pK_TranId).pipe(takeUntil(this.destroycounselor$)).subscribe((data) => {
        //  console.log(data);
      },err=>{
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
    }
  }

  getAllPackageList() {
    var id = 1;
    var date = this.dashboardService.selecteddate;
  this.ipdService
      .GetpackageList(this.getRateTypeVal, id, date).pipe(takeUntil(this.destroycounselor$))
      .subscribe((data) => {
        this.allPackageList = data;
        //  console.log('package', this.allPackageList);
      },err=>{
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }
  changeSelectedRateType(value) {
    let selectrateary = this.rateTypelist.filter(
      (item) => item.rateTypeId == value
    );
    this.emrService.counselorExamModel.rateType = selectrateary[0]?.rateTypeId;
    this.getRateTypeVal = selectrateary[0]?.rateType;
  }

  //Get Opertation Type
  GetotTypeData() {
    this.getOPTypeArray = [];
    try {
       this.ipdService.GetOPType().pipe(takeUntil(this.destroycounselor$)).subscribe((item) => {
        this.getOPTypeArray = item;
        this.OpTypeControll();
      },err=>{
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
    } catch (e) {}
  }

  OpTypeControll() {
    this.filteredOpTypeArray = this.OpTypeCtrl.valueChanges.pipe(
      startWith(""),
      map((opt) =>
        opt ? this.filterOpfunction(opt) : this.getOPTypeArray.slice()
      )
    );
  }

  filterOpfunction(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.getOPTypeArray.filter(
      (item) => item.operationTypeName?.toLowerCase().indexOf(filterValue) === 0
    );
  }

  GetOtTheatreData() {
    this.getOtTheatreArray = [];
    let BranchId = this.authservice.Loggeduser.branchid;
    try {
       this.ipdService.GetOtTheatre(BranchId).pipe(takeUntil(this.destroycounselor$)).subscribe((item) => {
        this.getOtTheatreArray = item;
        this.OTThreateControll();
      },err=>{
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
    } catch (e) {}
  }

  //Auto Ot Threate
  OTThreateControll() {
    this.filteredOTTheatreArray = this.OTTheatreCtrl.valueChanges.pipe(
      startWith(""),
      map((Otitem) =>
        Otitem ? this.filterOTfunction(Otitem) : this.getOtTheatreArray.slice()
      )
    );
  }

  filterOTfunction(name: string) {
    const len = Object.keys(name).length;
    if (len > 9) {
      return this.getOtTheatreArray.filter(
        (otname) => otname.theatreName.toLowerCase().indexOf(name) === 0
      );
    } else {
      return this.getOtTheatreArray.filter(
        (otname) =>
          otname.theatreName.toLowerCase().indexOf(name?.toLowerCase()) === 0
      );
    }
  }

  branchControll() {
    this.filteredbranchArray = this.branchCtrl.valueChanges.pipe(
      startWith(""),
      map((item) =>
        item
          ? this.filterbranchfunction(item)
          : this.authservice.Branches.slice()
      )
    );
  }
  filterbranchfunction(name: string) {
    return this.authservice.Branches.filter(
      (e) => e.branchName.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
  }

  getAlluser() {
    let userfilter;
    this.emrService.getUserTypeId().pipe(takeUntil(this.destroycounselor$)).subscribe((data) => {
      userfilter = data;
      this.DoctorListArray = userfilter.filter(
        (item) => (item.isAneasthetist == false || item.isAneasthetist == null)&& item.isActive == true
      );
      this.AnaeListArray = userfilter.filter(
        (item) => item.isAneasthetist == true && item.isActive == true
      );
      this.doctorControll();
      this.doctorControll2();
      this.asstdoctorControll();
      this.anaesthetistControll();
    },err=>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }

  doctorControll() {
    this.filteredDoctorArray = this.DoctorCtrl.valueChanges.pipe(
      startWith(""),
      map((item) =>
        item ? this.filterdoctorfunction(item) : this.DoctorListArray.slice()
      )
    );
  }

  filterdoctorfunction(name: string) {
    return this.DoctorListArray.filter(
      (dr) => dr.userName.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
  }

  getdoctorobj(e: any) {
    let constID = e.option.id;
    this.emrService.counselorExamModel.fK_MainSurgeronId = constID;
  }

  doctorControll2() {
    this.filteredDoctor2Array = this.DoctorCtrl2.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat ? this.filterdoctor2function(cat) : this.DoctorListArray.slice()
      )
    );
  }

  filterdoctor2function(name: string) {
    return this.DoctorListArray.filter(
      (country) =>
        country.userName.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
  }

  getdoctorobj2(e: any) {
    let constID2 = e.option.id;
    this.emrService.counselorExamModel.fK_CoSurgeronId = constID2;
  }

  asstdoctorControll() {
    this.filteredAsstDoctorArray = this.AsstDoctorCtrl.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat ? this.filterasstdoctorfunction(cat) : this.DoctorListArray.slice()
      )
    );
  }

  filterasstdoctorfunction(name: string) {
    return this.DoctorListArray.filter(
      (country) =>
        country.userName.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
  }

  anaesthetistControll() {
    this.filteredAnaeDoctorArray = this.AnaeDoctorCtrl.valueChanges.pipe(
      startWith(""),
      map((e) =>
        e ? this.filteranaestfunction(e) : this.AnaeListArray.slice()
      )
    );
  }

  filteranaestfunction(name: string) {
    return this.AnaeListArray.filter(
      (item) => item.userName.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
  }

  getasstdoctorobj(e: any) {
    let constID4 = e.option.id;
    this.emrService.counselorExamModel.fK_AssistantSurgeonId = constID4;
  }
  getanaedoctorobj(e: any) {
    let constID3 = e.option.id;
    this.aneastheticname = e.option.value;
    this.emrService.counselorExamModel.fK_AneastheticId = constID3;
  }

  getPartyname() {
     this.emrService.getPartytAll().pipe(takeUntil(this.destroycounselor$)).subscribe(
      (data) => this.success_partytpa(data),
      (err) => this.failed_partytpa(err)
    );
  }
  success_partytpa(data) {
    this.partynameArray = data;
    this.partyControll();
  }
  failed_partytpa(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  partyControll() {
    this.filteredPartyArray = this.PartyCtrl.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat ? this.filterpartyfunction(cat) : this.partynameArray.slice()
      )
    );
  }

  filterpartyfunction(name: string) {
    return this.partynameArray.filter(
      (party) => party.partyName.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
  }

  getPartyobj(e: any) {
    let partyId = e.option.id;
    this.emrService.counselorExamModel.fK_PartyId = partyId;
    this.getRateList(partyId);
  }

  getOTTheatreobj(e: any) {
    var val = e.option.value;
    this.OTTheatreName = val.theatreName;
    // this.OTTheatreId = val.pK_OTTheatreId;
    this.emrService.counselorExamModel.fK_TheatreId = val.pK_OTTheatreId;
  }

  CheckinputOTTheatre(event: any) {
    var checkdata = event.target.value;
    if (!checkdata) {
      this.OTThreateControll();
       this.emrService.counselorExamModel.fK_TheatreId = null;
    }
  }

  getOpTypeobj(e: any) {
    var val = e.option.value;
    this.opTypeName = val;
    this.emrService.counselorExamModel.fK_OperationTypeId = e.option.id;
    // this.opTypeId = val.pK_OperationTypeId;
  }
  GetbranchId(event) {
    this.emrService.counselorExamModel.fK_ForBranchId = event.option.id;
  }

  CheckinputOpType(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.emrService.counselorExamModel.fK_OperationTypeId = null;
      this.OpTypeControll();
    }
  }

  surgeryStatus(event) {
    let statusid = event;
    let bkstatus;
    bkstatus = this.surgeryStatusArray.filter(
      (item) => item.pK_SurgeryStatusId == statusid
    )[0];
    this.bookstatus = bkstatus.surgeryStatus;
    if (this.bookstatus == "Booked") {
      this.emrService.counselorExamModel.bookingDate =
        this.dashboardService.selecteddate;
      this.bookbyname = this.authservice.Loggeduser.username;
      this.emrService.counselorExamModel.fK_BookedById =
        this.authservice.Loggeduser.userid;

      this.cancelDisabled();
      this.postPostDis();
    } else if (this.bookstatus == "Postponed") {
      this.emrService.counselorExamModel.bookingDate = "";
      this.bookbyname = "";
      this.disPost = false;
      this.cancelDisabled();
    } else if (this.bookstatus == "Cancelled") {
      this.disCancel = false;
      this.emrService.counselorExamModel.bookingDate = "";
      this.bookbyname = "";
      this.postPostDis();
    } else {
      this.emrService.counselorExamModel.bookingDate = "";
      this.bookbyname = "";
      this.cancelDisabled();
      this.postPostDis();
    }
    this.emrService.counselorExamModel.surgeryStatus = this.bookstatus;
    this.emrService.counselorExamModel.fK_StatusId = statusid;
  }
  cancelDisabled() {
    this.disCancel = true;
    this.cancelDateDisabled = true;
    this.emrService.counselorExamModel.cancel_Date = "";
    this.emrService.counselorExamModel.cancel_Reason = "";
  }

  postPostDis() {
    this.disPost = true;
    this.postdisdate = true;
    this.emrService.counselorExamModel.postponed_Date = "";
    this.emrService.counselorExamModel.postponed_Reason = "";
  }
  counselorNo() {
    // let bookingbyid = this.authservice.users.filter(item => item.userName.toLowerCase() == this.authservice.Loggeduser.username);
    // this.userId = bookingbyid[0]?.pkUserId;
    this.emrService.counselorExamModel.counselorNo =
      this.authservice.Loggeduser.userid;
  }
  rateType() {
     this.emrService.getRateType().pipe(takeUntil(this.destroycounselor$)).subscribe((data) => {
      this.rateTypelist = data;
    },err=>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }

  getwardlist() {
  this.ipdService.getWardList().pipe(takeUntil(this.destroycounselor$)).subscribe((data) => {
      this.WardListArray = data;
    },err=>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }

  surgicalstatus(event) {
    this.surgicalchk = event.checked;
    this.emrService.counselorExamModel.isSurgical = this.surgicalchk;
  }

  getsurgeryStatus() {
    let surgeryfilter;
     this.emrService.getSugeryStatus().pipe(takeUntil(this.destroycounselor$)).subscribe((data) => {
      surgeryfilter = data;
      this.surgeryStatusArray = surgeryfilter.filter(
        (item) => item.isActive == true
      );
    },err=>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }

  // helplist pop up
  reflabstatusPOpup(name, type) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "33vw",
      disableClose: true,
      width: "33%",
      data: {
        parametertype: name,
      },
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroycounselor$)).subscribe((result) => {
      if (result != 0) {
        if (type == 1) {
          this.emrService.counselorExamModel.labstatus = result;
        } else if (type == 2) {
          this.casetype = result;
          this.emrService.counselorExamModel.patientType = result;
        } else if (type == 3) {
          this.emrService.counselorExamModel.postponed_Reason = result;
        } else if (type == 4) {
          this.emrService.counselorExamModel.cancel_Reason = result;
        } else if (type == 5) {
          this.emrService.counselorExamModel.remarks = result;
        }
      }
    });
  }

  anesthTpyePOpup(type) {
    const dialogRef = this.dialog.open(HelpListPopupComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "33vw",
      disableClose: true,
      width: "33%",
      data: {
        typeid: type,
      },
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroycounselor$)).subscribe((result) => {
      if (result != 0) {
        if (type == 2) {
          this.anesthtype = result;
          let atypeId = this.anerTypeList.filter(
            (item) => item.popupDescription == this.anesthtype
          )[0];
          this.emrService.counselorExamModel.fK_AnesthTypeId =
            atypeId.pkPopupId;
        }
      }
    });
  }

  addService() {
    if (this.checktpa == 0) {
      return this.dashboardService.openSnackBar(
        "Please Select Payor Name",
        "OK"
      );
    }
    const dialogRef = this.dialog.open(AddServiceComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      maxHeight: "90%",
      width: "80%",
      data: {
        RateType: this.emrService.counselorExamModel.rateType,
        BillEntryId: 1,
        Category_id: 1,
      },
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroycounselor$)).subscribe((result) => {
      // this.AddServiceArray = [];
      var result = this.billingservice.selectedServiceRow.reduce(
        (unique, o) => {
          if (
            !unique.some(
              (obj) =>
                obj.serviceName === o.serviceName &&
                obj.FK_ServiceId === o.FK_ServiceId
            )
          ) {
            unique.push(o);
          }
          return unique;
        },
        []
      );
      if (result.length > 0) {
        result.forEach((element, index) => {
          this.AddServiceArray.push({
            isEdit: false,
            isDelete: false,
            pK_TranID: 0,
            fK_CounselorId: 0,
            fK_ServiceId: element.serviceId,
            rate: element.rate,
            discountPer: element.discount,
            discount: element.discount,
            // "Amount": element.rate,
            amount: element.rateGeneral,
            spAmount: element.rateSemiPrivate,
            pAmount: element.ratePrivate,
            sdAmount: element.rateSemiDelux,
            dAmount: element.rateDelux,
            NetAmt: element.rate,
            serviceName: element.serviceName,
            maxDiscountLimit: element.maxDiscountLimit,
            ServiceCharges: element.serviceCharge,
          });
          //
        });

        this.AddServiceArray = this.AddServiceArray.reduce((unique, o) => {
          if (
            !unique.some(
              (obj) =>
                obj.serviceName === o.serviceName &&
                obj.FK_ServiceId === o.FK_ServiceId
            )
          ) {
            unique.push(o);
          }
          return unique;
        }, []);

        // const index = this.BillDetailArray.filter(list => list.FK_ServiceId == 0);
        // if (index.length > 0) {
        //   this.BillDetailArray.splice(index, 1);
        // }

        // this.serviceOrder_ds = this.AddServiceArray;

        // this.BillDetailArray.forEach((elem, index) => {
        //   if (elem.DiscountPercent > 0) {
        //     this.ondiscountPercentage(elem.DiscountPercent, index);
        //   }
        //   if (elem.ServiceCharges > 0) {
        //     this.onserviceChnage(elem.ServiceCharges, index);
        //   }
        //   //  else{
        //   //   elem.DiscountPercent =0;
        //   //   elem.ServiceCharges =0;

        //   //  }

        // });

        this.servicepaymentDetail();
      }
    });
  }
  updaterateType() {
    this.servicepaymentDetail();
    this.paymentDetail(this.PackageListArray);
  }
  servicepaymentDetail() {
    this.totalGAmount = 0;
    this.totalSPAmount = 0;
    this.totalPAmount = 0;
    this.totalSDAmount = 0;
    this.totalDAmount = 0;
    this.totalSAmount = 0;
    this.totalSdiscount = 0;
    let ratetype = this.emrService.counselorExamModel.rateType;

    if (this.AddServiceArray.length != 0) {
      this.AddServiceArray?.forEach((element) => {
        if (ratetype == 1) {
          console.log("general");
          this.totalGAmount = this.totalGAmount + parseInt(element.amount);
          this.totalSAmount = this.totalGAmount;
          if (element.discountPer > 0) {
            const discountSAmount =
              (parseInt(element.amount) * parseInt(element.discountPer)) / 100;
            this.totalSdiscount =
              parseInt(this.totalSdiscount) +
              this.stotaldiscount +
              parseInt(discountSAmount.toFixed(2));
          }
        } else if (ratetype == 2) {
          console.log("Semi-Private");
          this.totalSPAmount = this.totalSPAmount + parseInt(element.spAmount);
          this.totalSAmount = this.totalSPAmount;
          if (element.discountPer > 0) {
            const discountSAmount =
              (parseInt(element.spAmount) * parseInt(element.discountPer)) /
              100;
            this.totalSdiscount =
              parseInt(this.totalSdiscount) +
              this.stotaldiscount +
              parseInt(discountSAmount.toFixed(2));
          }
        } else if (ratetype == 3) {
          console.log("Private");
          this.totalPAmount = this.totalPAmount + parseInt(element.pAmount);
          this.totalSAmount = this.totalPAmount;
          if (element.discountPer > 0) {
            const discountSAmount =
              (parseInt(element.pAmount) * parseInt(element.discountPer)) / 100;
            this.totalSdiscount =
              parseInt(this.totalSdiscount) +
              this.stotaldiscount +
              parseInt(discountSAmount.toFixed(2));
          }
        } else if (ratetype == 4) {
          console.log("Semi-Delux");
          this.totalSDAmount = this.totalSDAmount + parseInt(element.sdAmount);
          if (element.discountPer > 0) {
            const discountSAmount =
              (parseInt(element.sdAmount) * parseInt(element.discountPer)) /
              100;
            this.totalSdiscount =
              parseInt(this.totalSdiscount) +
              this.stotaldiscount +
              parseInt(discountSAmount.toFixed(2));
          }
          this.totalSAmount = this.totalSDAmount;
        } else if (ratetype == 5) {
          console.log("Delux");
          this.totalDAmount = this.totalDAmount + parseInt(element.dAmount);
          this.totalSAmount = this.totalDAmount;
          if (element.discountPer > 0) {
            const discountSAmount =
              (parseInt(element.dAmount) * parseInt(element.discountPer)) / 100;
            this.totalSdiscount =
              parseInt(this.totalSdiscount) +
              this.stotaldiscount +
              parseInt(discountSAmount.toFixed(2));
          }
        }
      });
    }

    this.esttotalAmount = this.totalAmount + this.totalSAmount;
    this.finalDiscountAmount = this.totaldiscount + this.totalSdiscount;
    this.emrService.counselorExamModel.discount = this.finalDiscountAmount;
    this.emrService.counselorExamModel.totalSurgeryAmount = this.esttotalAmount;
    this.emrService.counselorExamModel.netEstimate =
      this.esttotalAmount - this.finalDiscountAmount;
  }

  onupdateSDisAmount(e: number, index: number) {
   
    if (e === null || e === undefined) {
      this.AddServiceArray[index].discountPer = 0;
    } else {
      if (e >= 0 && e <= 100) {
        this.AddServiceArray[index].discountPer = e;
        this.servicepaymentDetail();
        this.paymentDetail(this.PackageListArray);
      } else {
        this.AddServiceArray[index].discountPer = 0;
        this.servicepaymentDetail();
        this.dashboardService.openSnackBar(
          "Please Enter Percentage 0 to 100 ",
          "OK"
        );
      }
    }
  }

  onServiceupdateAmount(e: number, index: number, check: string) {
    if (e === null || e === undefined) {
    } else {
     // this.AddServiceArray[index].discountPer = e;
      this.onGridAmount(e, index, check);
      this.servicepaymentDetail();
      this.paymentDetail(this.PackageListArray);
    }
  }
  onGridAmount(value, index, ratetype) {
    if (ratetype == "GN") {
      this.AddServiceArray[index].amount = value;
    } else if (ratetype == "SP") {
      this.AddServiceArray[index].spAmount = value;
    } else if (ratetype == "PA") {
      this.AddServiceArray[index].pAmount = value;
    } else if (ratetype == "SD") {
      this.AddServiceArray[index].sdAmount = value;
    } else if (ratetype == "D") {
      this.AddServiceArray[index].dAmount = value;
    }
  }

  //otCOnsent call
  otConsentDocument() {
    const dialogRef = this.dialog.open(OTConsentComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "33vw",
      disableClose: true,
      width: "33%",
      data: {
        //  id: this.dashboardService.pid,
        eyetype: this.emrService.counselorExamModel.eye,
      },
    });
   dialogRef.afterClosed().pipe(takeUntil(this.destroycounselor$)).subscribe((result) => {});
  }

  //get rate list
  getRateList(event) {
    if (event != 0) {
      let BranchId = this.authservice.Loggeduser.branchid;
      let PartyId = event;
      this.billingservice
        .get_rate_list(BranchId, PartyId).pipe(takeUntil(this.destroycounselor$))
        .subscribe((data: any[]) => {
          this.billingservice.ratelist = data[0];
          if (data.length > 0) {
            this.checktpa = 1;
          }
          // this.billingservice.ratelist[0].rateListId
        },err =>{
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        });
    } else {
      this.billingservice.ratelist.rateList = "";
      this.checktpa = 0;
    }
  }
  serviceUpdateCheck() {
    this.addServiceDetailArray = [];
    let serviceFilter = this.AddServiceArray;
    if (serviceFilter.length != 0) {
      serviceFilter.forEach((element) => {
        this.addServiceDetailArray.push({
          IsEdit: element.fK_CounselorId == 0 ? false : true,
          IsDelete: false,
          PK_TranID: element.pK_TranID,
          FK_CounselorId: element.fK_CounselorId,
          FK_ServiceId: element.fK_ServiceId,
          Rate: element.rate,
          DiscountPer: element.discountPer,
          Discount: element.discount,
          Amount: element.amount,
          SPAmount: element.spAmount,
          PAmount: element.pAmount,
          SDAmount: element.sdAmount,
          DAmount: element.dAmount,
          serviceName: element.serviceName,
        });
      });
    }

    if (this.removeService.length != 0) {
      this.removeService.forEach((element) => {
        this.addServiceDetailArray.push({
          IsEdit: element.fK_CounselorId == 0 ? false : true,
          IsDelete: true,
          PK_TranID: element.pK_TranID,
          FK_CounselorId: element.fK_CounselorId,
          FK_ServiceId: element.fK_ServiceId,
          Rate: element.rate,
          DiscountPer: element.discountPer,
          Discount: element.discount,
          Amount: element.amount,
          SPAmount: element.spAmount,
          PAmount: element.pAmount,
          SDAmount: element.sdAmount,
          DAmount: element.dAmount,
          serviceName: element.serviceName,
        });
      });
    }
  }

  packageUpdateCheck() {
    this.packageDetailArray = [];
    let packageFilter = this.PackageListArray;
    if (packageFilter.length != 0) {
      packageFilter.forEach((element) => {
        this.packageDetailArray.push({
          pK_TranId: element.pK_TranId,
          fK_CounselorId: element.fK_CounselorId,
          fK_PackageId: element.fK_PackageId,
          amount: element.amount,
          discountPer: element.discountPer,
          IsEdit:
            element.fK_CounselorId == 0 || element.pK_TranId == 0
              ? false
              : true,
          isDelete: false,
          packageName: element.packageName,
          packageType: element.packageType,
        });
      });
    }

    if (this.removePackagedetail.length != 0) {
      this.removePackagedetail.forEach((element) => {
        this.packageDetailArray.push({
          pK_TranId: element.pK_TranId,
          fK_CounselorId: element.fK_CounselorId,
          fK_PackageId: element.fK_PackageId,
          amount: element.amount,
          discountPer: element.discountPer,
          IsEdit:
            element.fK_CounselorId == 0 || element.pK_TranId == 0
              ? false
              : true,
          isDelete: true,
          packageName: element.packageName,
          packageType: element.packageType,
        });
      });
    }
  }
  payorValidation(event: any) {
    let value = event.target.value;
    if (value == "") {
      this.showPartyName = "";
    }
  }
  locationValidation(event: any) {
    let value = event.target.value;
    if (value == "") {
      this.emrService.counselorExamModel.branchName = "";
      this.authservice.getallbranches();
    }
  }
  surgeryDetailArray: any;
  addServiceDetailArray: any;
  packageDetailArray: any;
  convertTime12to24 = (time12h) => {
    const [fullMatch, time, modifier] = time12h.match(
      /(\d?\d:\d\d)\s*(\w{2})/i
    );

    let [hours, minutes] = time.split(":");

    if (hours === "12") {
      hours = "00";
    }

    if (modifier === "PM") {
      hours = parseInt(hours, 10) + 12;
    }

    return `${hours}:${minutes}`;
  };
  

   //check condition 
   SurgeronNameValidation: boolean = false;
   opTypeNameValidation: boolean = false;
   eyeNameValidation: boolean = false;
   showPartyNameValidation: boolean = false;
   bookingValidation: boolean = false;
   casetypeValidation:boolean = false;
   ratetypeValidation:boolean = false;
   anaetypeValidation:boolean = false;

   // save
  saveCouselor() {
    if (this.emrService.counselorExamModel.fK_ExamId == null) {
      this.emrService.counselorExamModel.fK_ExamId = 0;
      //return this.dashboardService.openSnackBar("Please Select Show Examination", "OK");
    }
    
    if (this.emrService.counselorExamModel.fK_StatusId == null) {
      this.disabledreceptbutton = false;
      this.bookingValidation = true;
      setTimeout(() => {
        this.bookingautoRef.nativeElement.focus();
      }, 100);
      return this.dashboardService.openSnackBar(
        "Please Select Booking Status",
        "OK"
      );
    }
    if (
      this.emrService.counselorExamModel.fK_ForBranchId == null ||
      this.emrService.counselorExamModel.branchName == ""
    ) {
      this.disabledreceptbutton = false;
      return this.dashboardService.openSnackBar("Please Select Location", "OK");
    }
    if (
      this.mainSurgeronName == "" ||
      this.emrService.counselorExamModel.fK_MainSurgeronId == null
    ) {
      this.SurgeronNameValidation = true;
      setTimeout(() => {
        this.SurgeronNameautoRef.nativeElement.focus();
      }, 100);
      this.disabledreceptbutton = false;
      return this.dashboardService.openSnackBar(
        "Please Select Main Surgeon",
        "OK"
      );
    }
    if (this.emrService.counselorExamModel.fK_OperationTypeId == null) {
      this.disabledreceptbutton = false;
      this.opTypeNameValidation = true;
      setTimeout(() => {
        this.opTypeNameautoRef.nativeElement.focus();
      }, 100);
      return this.dashboardService.openSnackBar(
        "Please Select Operation Type",
        "OK"
      );
    }
    if(this.emrService.counselorExamModel.patientType == null){
      this.disabledreceptbutton = false;
      this.casetypeValidation = true
      setTimeout(() => {
        this.caseautoRef.nativeElement.focus();
      }, 100);
      return this.dashboardService.openSnackBar(
        "Please Select Case Type",
        "OK"
      );
    }
    if(this.emrService.counselorExamModel.rateType == null){
      this.disabledreceptbutton = false;
      this.ratetypeValidation = true
      setTimeout(() => {
        this.rateTypeautoRef.nativeElement.focus();
      }, 100);
      return this.dashboardService.openSnackBar(
        "Please Select Rate Type",
        "OK"
      );
    }
    if(this.emrService.counselorExamModel.fK_AnesthTypeId == null || this.anesthtype == null  ){
      this.disabledreceptbutton = false;
      this.anaetypeValidation = true
      setTimeout(() => {
        this.aneatypeautoRef.nativeElement.focus();
      }, 100);
      return this.dashboardService.openSnackBar(
        "Please Select Anae. Type",
        "OK"
      );
    }
    if (
      this.emrService.counselorExamModel.eye == "" ||
      this.emrService.counselorExamModel.eye == null
    ) {
      this.eyeNameValidation = true;
      setTimeout(() => {
        this.eyeNameautoRef.nativeElement.focus();
      }, 100);
      this.disabledreceptbutton = false;
      return this.dashboardService.openSnackBar("Please Select Eye", "OK");
    }
    if (
      this.emrService.counselorExamModel.fK_PartyId == null ||
      this.showPartyName == ""
    ) {
      this.showPartyNameValidation = true;
      setTimeout(() => {
        this.PartyNameautoRef.nativeElement.focus();
      }, 100);
      this.disabledreceptbutton = false;
      return this.dashboardService.openSnackBar(
        "Please Select Payor Name",
        "OK"
      );
    }

    if (
      this.emrService.counselorExamModel.cancel_Date != null &&
      this.emrService.counselorExamModel.cancel_Date != ""
    ) {
      if (
        Date.parse(
          this.datePipe
            .transform(
              this.emrService.counselorExamModel.cancel_Date,
              "yyyy-MM-dd"
            )
            .toString()
        ) >=
        Date.parse(
          this.datePipe
            .transform(this.authservice.getServerDate, "yyyy-MM-dd")
            .toString()
        )
      ) {
      } else {
        this.disabledreceptbutton = false;
        return this.dashboardService.openSnackBar(
          "Select Present or future date",
          "OK"
        );
      }
    }
    if (
      this.emrService.counselorExamModel.postponed_Date != null &&
      this.emrService.counselorExamModel.postponed_Date != ""
    ) {
      if (
        Date.parse(
          this.datePipe
            .transform(
              this.emrService.counselorExamModel.postponed_Date,
              "yyyy-MM-dd"
            )
            .toString()
        ) >=
        Date.parse(
          this.datePipe
            .transform(this.authservice.getServerDate, "yyyy-MM-dd")
            .toString()
        )
      ) {
      } else {
        this.disabledreceptbutton = false;
        return this.dashboardService.openSnackBar(
          "Select Present or future date",
          "OK"
        );
      }
    }
    if (
      this.bookstatus == "Cancelled" &&
      this.emrService.counselorExamModel.cancel_Reason == ""
    ) {
      this.disabledreceptbutton = false;
      return this.dashboardService.openSnackBar(
        "Please enter reason for Cancellation",
        "OK"
      );
    } else if (
      this.bookstatus == "Postponed" &&
      this.emrService.counselorExamModel.postponed_Reason == ""
    ) {
      this.disabledreceptbutton = false;
      return this.dashboardService.openSnackBar(
        "Please enter reason for Postpone",
        "OK"
      );
    }
    this.surgeryDetailArray = [];
    let fileterdata;
    fileterdata = this.booksurgery_ds;
    // let surgerylist = fileterdata.filter(item => item.pK_TranId == 0);
    var pstrings=[];
    if (this.surgeryMainArray.length > 0) {
      fileterdata.forEach((item) => {
        this.surgeryDetailArray.push({
          FK_SurgeonId: item.fK_SurgeonId,
          FK_QualifierId: item.fK_QualifierId,
          FK_SurgeryId: item.fK_SurgeryId,
          FK_CounselorId: item.fK_CounselorId,
          PK_TranId: item.pK_TranId,
          PK_SynchId: item.pK_SynchId,
          Remarks: item.remarks,
          IsDelete: false,
          IsEdit: item.pK_TranId != 0 ? true : false,
        });
        pstrings.push(item.surgeryName);
        
      });
      if(pstrings.length >0){
        this.emrService.counselorExamModel.procedureName= pstrings.join(', ');
      }
     
    }

    if (this.deleteSurgeryList.length != 0) {
      this.surgeryDetailArray = this.deleteSurgeryList.concat(
        this.surgeryDetailArray
      );
    }
    this.emrService.counselorExamModel.fK_TheatreId=this.emrService.counselorExamModel.fK_TheatreId==0?null:this.emrService.counselorExamModel.fK_TheatreId;
    this.emrService.counselorExamModel.fK_AssistantSurgeonId=this.emrService.counselorExamModel.fK_AssistantSurgeonId==0?null:this.emrService.counselorExamModel.fK_AssistantSurgeonId;
    this.serviceUpdateCheck();
    this.packageUpdateCheck();

    let payload = {
      OpdCounselorExamination: this.emrService.counselorExamModel,
      OpdCounselorPackageDetail: this.packageDetailArray,
      OpdCounselorSurgeryDetail: this.surgeryDetailArray,
      PackageUpgradeDetail: [],
      CounselorAdditionalServiceDetail: this.addServiceDetailArray,
    };

    if (this.emrService.counselorExamModel.pK_CounselorId == 0) {
      if (this.emrService.counselorPermission.isAddPermission != true) {
        return this.dashboardService.openSnackBar("Add Permisson Denied", "ok");
      }
      // New record
      //  if(this.emrService.counselorExamModel.surgeryDate !=null && this.emrService.counselorExamModel.surgeryDate!=''){
      //   if (Date.parse(this.datePipe.transform(this.emrService.counselorExamModel.surgeryDate, "yyyy-MM-dd").toString()) == Date.parse(this.datePipe.transform(this.authservice.getServerDate, "yyyy-MM-dd").toString())) {
      //      if((this.convertTime12to24(this.emrService.counselorExamModel.surgeryTime)) >=this.convertTime12to24( moment(this.authservice.localDate).format("h:mm A"))){

      //      }else {
      //       return this.dashboardService.openSnackBar("Please select Surgery Time in Present or Future.", "OK");
      //      }
      //   }
      //  }
      //  if(this.emrService.counselorExamModel.surgeryDate !=null && this.emrService.counselorExamModel.surgeryDate!=''){
      //   if (Date.parse(this.datePipe.transform(this.emrService.counselorExamModel.surgeryDate, "yyyy-MM-dd").toString()) == Date.parse(this.datePipe.transform(this.authservice.getServerDate, "yyyy-MM-dd").toString())) {
      //      if((this.convertTime12to24(this.emrService.counselorExamModel.reportingTime)) >=this.convertTime12to24( moment(this.authservice.localDate).format("h:mm A"))){

      //      }else {
      //       return this.dashboardService.openSnackBar("Please select Reporting Time in Present or Future.", "OK");
      //      }
      //   }
      //  }
      this.emrService.counselorExamModel.isActive = true;
      this.emrService.counselorExamModel.isEdit = false;
      this.emrService.counselorExamModel.isDelete = false;
      this.emrService.counselorExamModel.fK_AdvicedById =
        this.emrService.counselorExamModel.fK_AdvicedById == null
          ? this.emrService.counselorExamModel.fK_MainSurgeronId
          : this.emrService.counselorExamModel.fK_AdvicedById;
      this.emrService.counselorExamModel.fK_CreatedById =
        this.authservice.Loggeduser.userid;
      this.emrService.counselorExamModel.counselorNo =
        this.authservice.Loggeduser.userid;
       this.counselorService.saveExamCounselor(payload).pipe(takeUntil(this.destroycounselor$)).subscribe((data) => {
        this.disabledreceptbutton = false;
        pstrings=[]
        if (data["statusCode"] == 1) {
          this.emrService.savedrWorkupTrackingSatus(
            "Counselor Workup",
            "false",
            "CS"
          );
          this.emrService.getPExamStatus();
          this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
          this.countrackinDetails(data["id"]);
          this.getCounselorId(this.regid);
        } else {
          this.disabledreceptbutton = false;
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      },err =>{
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
    } else {
      if (this.emrService.counselorPermission.isModifyPermission != true) {
        this.disabledreceptbutton = false;
        return this.dashboardService.openSnackBar(
          "Modify Permisson Denied",
          "ok"
        );
      }
      // Update record
      this.emrService.counselorExamModel.isEdit = true;
      this.emrService.counselorExamModel.isDelete = false;
      this.emrService.counselorExamModel.isActive = true;
      this.emrService.counselorExamModel.fK_ModifiedById =
        this.authservice.Loggeduser.userid;
      this.emrService.counselorExamModel.modifiedDateTime =
        this.authservice.getServerDate;
      this.emrService.counselorExamModel.counselorNo =
        this.authservice.Loggeduser.userid;

       this.counselorService.saveExamCounselor(payload).pipe(takeUntil(this.destroycounselor$)).subscribe((data) => {
        this.disabledreceptbutton = false;
        if (data["statusCode"] == 1) {
          this.emrService.savedrWorkupTrackingSatus(
            "Modify Counselor Workup",
            "true",
            "CS"
          );
          this.dashboardService.openSnackBar(
            "Record Updated Successfully",
            "OK"
          );
          this.countrackinDetails(data["id"]);
          this.getCounselorId(this.regid);
        } else {
          this.disabledreceptbutton = false;
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      },err=>{
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
    }
  }
  nxtdatedisabled(event) {
    let chk = event.checked;
    this.nxtdate = !chk;
  }
  postdisabled(event) {
    let postchk = event.checked;
    this.postdisdate = !postchk;
  }
  canceldisabled(event) {
    let cancelchk = event.checked;
    this.cancelDateDisabled = !cancelchk;
  }
  deleteSurgeryList = [];
  deletesurgery(row) {
    let tranId = row.pK_TranId;
    let deldataList;
    deldataList = this.booksurgery_ds;
    if (tranId > 0) {
      const index: number = deldataList.indexOf(row);
      if (index !== -1) {
        let test = deldataList.splice(index, 1);
        let item = test[0];
        this.deleteSurgeryList.push({
          FK_SurgeonId: item.fK_SurgeonId,
          FK_QualifierId: item.fK_QualifierId,
          FK_SurgeryId: item.fK_SurgeryId,
          FK_CounselorId: item.fK_CounselorId,
          PK_TranId: item.pK_TranId,
          PK_SynchId: item.pK_SynchId,
          Remarks: item.remarks,
          IsDelete: true,
          IsEdit: true,
        });
        this.booksurgery_ds = deldataList.slice();
      }
    } else {
      const index: number = deldataList.indexOf(row);
      if (index !== -1) {
        deldataList.splice(index, 1);
        this.booksurgery_ds = deldataList.slice();
        this.surgeryMainArray = deldataList.slice();
      }
    }
  }
  success_delete_surgeryhistory(data) {
    this.surgeryDetails(this.emrService.counselorExamModel.pK_CounselorId);
    this.dashboardService.openSnackBar("Surgery successfully deleted", "OK");
  }
  failed_delete_surgeryhistory(err) {}
  getsurgerydetails(item) {
    let sname = item.surgeryName;
    this.surgeryMainArray.push({
      pK_TranId: 0,
      fK_ExamId: item.fK_ExamId,
      fK_SurgeryId: item.fK_SurgeryId,
      fK_QualifierId: item.fK_QualifierId == null ? 0 : item.fK_QualifierId,
      fK_SurgeonId: item.fK_SurgeonId ? item.fK_SurgeonId : 0,
      remarks: item.remarks,
      pK_SynchId: item.pK_SynchId == null ? null : item.pK_SynchId,
      oldExamId: item.oldExamId,
      isDeleted: false,
      surgeryName: item.surgeryName,
      qualifierName: item.qualifierName,
      SurgeonName: item.surgeon,
      isEdit: false,
      eye: item.remarks,
      fK_CounselorId: 0,
    });
    var resultary = this.surgeryMainArray.reduce((unique, o) => {
      if (
        !unique.some(
          (obj) =>
            obj.surgeryName === o.surgeryName &&
            obj.fK_SurgeryId === o.fK_SurgeryId &&
            o.eye.toLowerCase() == obj.eye.toLowerCase()
        )
      ) {
        unique.push(o);
      }
      return unique;
    }, []);
    let seleye = resultary.filter((item) => item.surgeryName == sname)[0];
    this.emrService.counselorExamModel.eye = seleye.eye;
    this.booksurgery_ds = resultary;
  }

  checkdate(event, type) {
    console.log(event);
    let selectedDate = event;
    if (this.MinimeDate > selectedDate) {
      switch (type) {
        case "surgrydate": {
          this.emrService.counselorExamModel.surgeryDate = this.MinimeDate;
          break;
        }
        case "rptdate": {
          this.emrService.counselorExamModel.reportingDate = this.MinimeDate;
          break;
        }
        case "cnldate": {
          this.emrService.counselorExamModel.cancel_Date = this.MinimeDate;
          break;
        }
        case "nxtdate": {
          this.emrService.counselorExamModel.nextFollowupDate = this.MinimeDate;
          break;
        }
        case "postdate": {
          this.emrService.counselorExamModel.postponed_Date = this.MinimeDate;
          break;
        }
      }
      return this.dashboardService.openSnackBar(
        "Select Present or future date",
        "OK"
      );
    }
  }

  selectOtScheduleModal() {
    document.getElementById("selectOTScheduleModal").style.display = "block";
  }
  cancelselectOtScheduleModal() {
    document.getElementById("selectOTScheduleModal").style.display = "none";
  }

  //hiding Book Room/Bed
  bookRoomBed = false;
  selectOT = true;

  //onclick Book Room/Bed
  roomBedBooking() {
    this.selectOT = false;
    this.bookRoomBed = true;
  }

  bookConfirmationModal() {
    document.getElementById("bookConfirmationModal").style.display = "block";
  }
  cancelBookConfirmationModal() {
    document.getElementById("bookConfirmationModal").style.display = "none";
  }

  OTBookingListModal() {
    document.getElementById("OTBookingListModal").style.display = "block";
  }
  cancelOTBookingListModal() {
    document.getElementById("OTBookingListModal").style.display = "none";
  }

  //hiding Confirm box
  beforeConfirm = true;
  bookConfirm = false;

  //onclick Confirm box
  confirmBook() {
    this.beforeConfirm = false;
    this.bookConfirm = true;
  }

  numberOnly(event: any) {
    if (event > 0) {
      return true;
    } else {
      return false;
    }
  }

  //Surgery and Reporting Time
  surgeryReportTime(type: string) {
    this.lblname = type;
    this.timeFormatArray = [];
    this._value = 0;
    this._hourvalue = 1;
    document.getElementById("surgeryTimeModal").style.display = "block";
  }
  CancelsurgeryTime() {
    document.getElementById("surgeryTimeModal").style.display = "none";
  }

  color: any;
  _value: number = 0;
  _hourvalue: number = 1;
  _step: number = 1;
  _min: number = 0;
  _max: number = 59;
  _hourmax: number = 12;
  _wrap: boolean = false;

  myFormGroup = new FormGroup({
    formField: new FormControl(),
  });

  set inputValue(_value: number) {
    this._value = this.parseNumber(_value);
  }

  set step(_step: number) {
    this._step = this.parseNumber(_step);
  }

  set min(_min: number) {
    this._min = this.parseNumber(_min);
  }

  set max(_max: number) {
    this._max = this.parseNumber(_max);
  }

  set hourmax(_hourmax: number) {
    this._hourmax = this.parseNumber(_hourmax);
  }

  set wrap(_wrap: boolean) {
    this._wrap = this.parseBoolean(_wrap);
  }

  private parseNumber(num: any): number {
    return +num;
  }

  private parseBoolean(bool: any): boolean {
    return !!bool;
  }

  setColor(color: string): void {
    this.color = color;
  }

  getColor(): string {
    return this.color;
  }

  incrementValue(step: number = 1): void {
    let inputValue = this._value + step;

    if (this._wrap) {
      inputValue = this.wrappedValue(inputValue);
    }
    this._value = inputValue;
  }

  hoursincrementValue(step: number = 1): void {
    let hourinputValue = this._hourvalue + step;

    if (this._wrap) {
      hourinputValue = this.hourwrappedValue(hourinputValue);
    }

    this._hourvalue = hourinputValue;
  }

  private wrappedValue(inputValue): number {
    if (inputValue > this._max) {
      return this._min + inputValue - this._max;
    }

    if (inputValue < this._min) {
      if (this._max === 12) {
        return 0;
      }

      return this._max + inputValue;
    }

    return inputValue;
  }

  private hourwrappedValue(hourinputValue): number {
    if (hourinputValue > this._hourmax) {
      return this._min + hourinputValue - this._hourmax;
    }

    if (hourinputValue < this._min) {
      if (this._hourmax === 59) {
        return 0;
      }

      return this._hourmax + hourinputValue;
    }

    return hourinputValue;
  }

  shouldDisableDecrement(inputValue: number): boolean {
    return !this._wrap && inputValue <= this._min;
  }

  shouldDisableIncrement(inputValue: number): boolean {
    return !this._wrap && inputValue >= this._max;
  }

  hourshouldDisableDecrement(hourinputValue: number): boolean {
    return !this._wrap && hourinputValue <= 1;
  }

  hourshouldDisableIncrement(hourinputValue: number): boolean {
    return !this._wrap && hourinputValue >= this._hourmax;
  }

  changeFormat(event: any) {
    this.timeFormatcheck = event;
  }
  // add time
  timeFormatArray: any = [];
  addTime(hr, min) {
    if (hr > 12 || min > 59 || min == null || hr == null) {
      return this.dashboardService.openSnackBar("Select Valid Time", "OK");
    } else if (hr < 1 || min < 0) {
      return this.dashboardService.openSnackBar("Select Valid Time", "OK");
    }
    let bindtime = hr + ":" + min + " " + this.timeFormatcheck;
    if (this.lblname == "Surgery") {
      this.emrService.counselorExamModel.surgeryTime = bindtime;
    } else if (this.lblname == "Reporting") {
      this.emrService.counselorExamModel.reportingTime = bindtime;
    }
    this.CancelsurgeryTime();
  }

  disabledlist(event) {
    if (event) {
      let checkdata = this.PackageListArray.filter(
        (item) => item.fK_PackageId == event
      );
      if (checkdata.length > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  //Surgery Selection
  surgerySelections() {
    document.getElementById("surgerySelectionModals").style.display = "block";
  }
  CancelSurgerySelection() {
    // this.enabledisablebtn=true;
    if (this.selectedSugeryArray.length > 0) {
      for (var i = 0; i < this.selectedSugeryArray.length; i++) {
        let itemdata = this.helplistsergery.filter(
          (item) => item.pkSurgeryId == this.selectedSugeryArray[i].pkSurgeryId
        );
        if (itemdata) {
          itemdata[0].isEdit = null;
        }
      }
    }
    this.selectedSugeryArray = [];

    document.getElementById("surgerySelectionModals").style.display = "none";
  }
  showSurgeryOptions(event: MatCheckboxChange, row: any, i): void {
    if (event.checked == true) {
      this.helplistsergery[i].isEdit = false;
      this.selectedSugeryArray.push({
        ...row,
        eye: this.eyetype,
      });
    } else {
      this.helplistsergery[i].isEdit = null;
      this.selectedSugeryArray = this.selectedSugeryArray.filter(
        (item) => item.pkSurgeryId != row.pkSurgeryId
      );
    }
  }
  selectDeleterow(row: any) {
    const index: number = this.selectedSugeryArray.indexOf(row);
    if (index !== -1) {
      const findindex = this.helplistsergery.findIndex(
        (item) => item.pkSurgeryId == row.pkSurgeryId
      );
      this.helplistsergery[findindex].isEdit = null;
      this.selectedSugeryArray.splice(index, 1);
    }
  }
  transferDataMains() {
    if (this.selectedSugeryArray.length > 0) {
      // this.enabledisablebtn=false;
      // if ( this.opdvisitService.DoctorIdEmr > 0) {
      // if (this.examid == null || this.examid == undefined) {
      //   this.examid = 0;
      // }
      for (var i = 0; i < this.selectedSugeryArray.length; i++) {
        let itemdata = this.helplistsergery.filter(
          (item) => item.pkSurgeryId == this.selectedSugeryArray[i].pkSurgeryId
        );
        if (itemdata) {
          itemdata[0].isEdit = null;
        }
        this.surgeryMainArray.push({
          pK_TranId: 0,
          fK_ExamId: 0,
          fK_SurgeryId: this.selectedSugeryArray[i].pkSurgeryId,
          fK_QualifierId: 0,
          // "fK_SurgeonId": this.opdvisitService.DoctorIdEmr?this.opdvisitService.DoctorIdEmr:0,
          fK_SurgeonId: this.emrService.counselorExamModel.fK_MainSurgeronId
            ? this.emrService.counselorExamModel.fK_MainSurgeronId
            : 0,
          remarks: this.selectedSugeryArray[i].eye,
          pK_SynchId: 0,
          oldExamId: 0,
          isDeleted: 0,
          surgeryName: this.selectedSugeryArray[i].surgeryName,
          qualifierName: null,
          // 'SurgeonName': this.opdvisitService.doctors.filter(item=>item.userId ==this.opdvisitService.DoctorIdEmr)[0].userName,
          isEdit: false,
          SurgeonName: this.mainSurgeronName,
          eye: this.selectedSugeryArray[i].eye,
          fK_CounselorId: 0,
        });
      }

      var resultt = this.surgeryMainArray.reduce((unique, o) => {
        if (
          !unique.some(
            (obj) =>
              obj.surgeryName === o.surgeryName &&
              obj.fK_SurgeryId === o.fK_SurgeryId
          )
        ) {
          unique.push(o);
        }
        return unique;
      }, []);

      this.booksurgery_ds = resultt;
      this.selectedSugeryArray = [];
      document.getElementById("surgerySelectionModals").style.display = "none";

      // } else {
      //   this.dashboardService.openSnackBar("Doctor Id is Required", "OK");
      // }
    } else {
      this.dashboardService.openSnackBar("Please Select Surgery", "OK");
    }
  }

  newsurgery() {
    const dialogRef = this.dialog.open(OtherSurgeryPopupComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "90vw",
      disableClose: true,
      width: "80%",
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroycounselor$)).subscribe((result) => {
      let sname;
      if (result.length > 0) {
        result.forEach((item) => {
          sname = item.surgeryName;
          this.surgeryMainArray.push({
            pK_TranId: 0,
            fK_ExamId: 0,
            fK_SurgeryId: item.pkSurgeryId,
            fK_QualifierId:
              item.fK_QualifierId == null ? 0 : item.fK_QualifierId,
            fK_SurgeonId: this.serchdoctorName(item.SurgeonName)
              ? this.serchdoctorName(item.SurgeonName)
              : 0,
            remarks: item.eye,
            pK_SynchId: item.pkSynchId,
            oldExamId: 0,
            isDeleted: false,
            surgeryName: item.surgeryName,
            qualifierName: item.qualifierName,
            SurgeonName: item.SurgeonName,
            isEdit: false,
            eye: item.eye,
            fK_CounselorId: 0,
          });
        });
      }
 
      var resultary = this.surgeryMainArray.reduce((unique, o) => {
        if (
          !unique.some(
            (obj) =>
              obj.surgeryName === o.surgeryName &&
              obj.fK_SurgeryId === o.fK_SurgeryId &&
              obj.eye.toLowerCase() == o.eye.toLowerCase()
          )
        ) {
          unique.push(o);
        }
        return unique;
      }, []);
      let seleye = resultary.filter((item) => item.surgeryName == sname)[0];
      if (seleye.remarks == "Both") {
        this.emrService.counselorExamModel.eye = "BE";
      } else if (seleye.remarks == "Right" || seleye.remarks == "RE") {
        this.emrService.counselorExamModel.eye = "RE";
      } else if (seleye.remarks == "Left" || seleye.remarks == "LE") {
        this.emrService.counselorExamModel.eye = "LE";
      } else if (seleye.remarks == "None") {
        this.emrService.counselorExamModel.eye = "None";
      }
      this.booksurgery_ds = resultary;
    });
  }
  getsummary_url(patientid: number, type: any) {
  
    if (this.opdvisitService.patientdetails.pkRegId) {
      if (type == 0) {
        let checkreporttype = this.authservice.webreportConfig.filter(
          (item) =>
            item.printOption == "Medical Record" &&
            item.printType == "NetramReport"
        );
        if (checkreporttype.length > 0) {
          this.dashboardService.getsummary_url().pipe(takeUntil(this.destroycounselor$)).subscribe(
            (data) => this.succesurl(data, patientid,type),
            (err) => this.failedurl(err)
          );
        } else {
          this.printTimelineBill(type);
        }
      } else if (type == 1) {
        this.printTimelineBill(type);
      }else if (type == 2) {
        this.dashboardService.getsummary_url().pipe(takeUntil(this.destroycounselor$)).subscribe(
          (data) => this.succesurl(data, patientid,type),
          (err) => this.failedurl(err)
        );
      }
    } else {
      this.dashboardService.openSnackBar("Please Select Patient", "OK");
    }
  }
  succesurl(data, patientid,type) {
    const urldate = data.filter((item) => item.propertyName == "WebURL");
    const pageheader = data.filter(
      (item) => item.propertyName == "PageHeadWebReport"
    );
    const checktrue = pageheader[0]?.propertyValue;
    const url = urldate[0].propertyValue;
    if(type==0){
      window.open(
        url +
          "PatientEMRSummary.aspx?RegID=" +
          patientid +
          "&BillCompanyName=" +
          this.authservice.Loggeduser.billingcompanyname +
          "&VisitOrderType=DESC" +
          "&BranchId=" +
          this.authservice.Loggeduser.branchid
      );
    }else if(type ==2){
      window.open(
        url +
          "TodayEMRVisitDayCaseSheet.aspx?VisitId=" +
          this.emrService.visitid +"&VisitDate="+this.datePipe.transform(
            this.emrService.visitDate,
            "dd-MM-yyyy"
          )+
          "&BillCompanyName=" +
          this.authservice.Loggeduser.billingcompanyname +
          "&VisitOrderType=ASC" +"&PageHeadWebReport=Y"+
          "&BranchId=" +
          this.authservice.Loggeduser.branchid
      );
    }
    
  }
  printTimelineBill(type) {
 
    let payload = {
      WebReportPrintMaster: {
        module: (type == 0 ? "Doctor" : "Counsellor"),
        printOption: (type ==0 ? "Medical Record" : "Surgery Booking Slip"),
        printType: "WebNetramReport",
        PRINTDATE: this.datePipe.transform(
          this.authservice.localDate,
          "dd-MM-yyyy"
        ),
        PrintTime: this.emrService.convertTime12Hour(new Date()),
        Pk_RegId: this.opdvisitService.patientdetails.pkRegId,
        PATIENTNAME:
          this.opdvisitService.patientdetails.initial +
          " " +
          this.opdvisitService.patientdetails.firstName +
          " " +
          this.opdvisitService.patientdetails.lastName,
        MRDNO: this.opdvisitService.patientdetails.pkRegId,
        BILLINGCOMPANYNAME: this.authservice.Loggeduser.billingcompanyname,
        PRINTCONFIGURATIONARRAY: "N",
        Pk_VisitId: (type == 0 ? 0 : this.emrService.visitid),
        Pk_ExamId: 0,
        VISITDATE: this.datePipe.transform(
          this.emrService.visitDate,
          "dd-MM-yyyy"
        ),
        LINE1: this.emrService.branchmansterObj.line1,
        LINE2: this.emrService.branchmansterObj.line2,
        LINE3: this.emrService.branchmansterObj.line3,
        LINE4: this.emrService.branchmansterObj.line4,
        HOSPITALIMAGE: "../../../" + this.authservice.loginclientlogo,
        COMPANYIMAGE: "../../../" + this.authservice.leftbottomlogosm,
        CERTIFICATE1IMAGE: "../../../" + this.authservice.nabhlogo,
        CERTIFICATE2COMPANYIMAGE: "",
        PrintHeaderArray: (type == 0 ? "Y" : "N"),
        PatientRegistrationArray:"Y",
        VisitMasterArray: (type == 0 ? "Y" : "N"),
        HistoryGeneralArray: (type == 0 ? "Y" : "N"),
        DoctorExaminationMasterArray: (type == 0 ? "Y" : "N"),
        AutoRefExaminationArray: (type == 0 ? "Y" : "N"),
        HistoryDiseaseArray: (type == 0 ? "Y" : "N"),
        CounselorExaminationArray: "Y",
        HistorySurgicalArray: (type == 0 ? "Y" : "N"),
        HistoryFamilyArray: (type == 0 ? "Y" : "N"),
        HistoryDrugAllergyArray: (type == 0 ? "Y" : "N"),
        PresentingComplaintsArray: (type == 0 ? "Y" : "N"),
        AdvisedInvestigationsArray: (type == 0 ? "Y" : "N"),
        IntraocularPressureArray: (type == 0 ? "Y" : "N"),
        OptoExaminationArray: (type == 0 ? "Y" : "N"),
        OptoTestDetailArray: (type == 0 ? "Y" : "N"),
        OptoSlitLampExaminationArray: (type == 0 ? "Y" : "N"),
        CurrentMedicationDetailArray: (type == 0 ? "Y" : "N"),
        DoctorFindingArray: (type == 0 ? "Y" : "N"),
        DoctorInvestigationArray: (type == 0 ? "Y" : "N"),
        DoctorDiagnosisArray: (type == 0 ? "Y" : "N"),
        DoctorPrescriptionArray: (type == 0 ? "Y" : "N"),
        DoctorSurgeryArray: (type == 0 ? "Y" : "N"),
      },
    };
   this.ipdService.GetWebReportPrint(payload).pipe(takeUntil(this.destroycounselor$)).subscribe(
      (x: any) => {
        if (x.length > 0) {
          let printContents, popupWin;

          printContents = x[0].printTemplate;
          popupWin = window.open(
            "",
            "_blank",
            "top=0,left=0,height=100%,width=auto"
          );

          popupWin.document.open();
          popupWin.document.write(`
  <html>
   
  <body onload="window.print()">${printContents}
  </body>
  </html>`);

          popupWin.document.close();
        } else {
          this.dashboardService.openSnackBar("Report Template Not Set", "OK");
        }
      },
      (err) => {
        this.dashboardService.openSnackBar("Api Failed", "OK");
      }
    );
  }
  failedurl(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  closedialog() {
    this.dialogRef.close();
  }

  //call corporate detail

  addCorporateDetail() {
    if (this.emrService.counselorExamModel.pK_CounselorId > 0) {
      this.ipdService.content.next({});

      const dialogRef = this.dialog.open(CorporateDetailComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "100vw !important",
        height: "100%",
        width: "100%",
        data: {
          partyip: this.emrService.counselorExamModel.fK_PartyId,
          billId: 0,
          balanceAmount: 0,
          ipdId: 0,
          counsid: this.emrService.counselorExamModel.pK_CounselorId,
          screentype: "counselor",
        },
      });

      dialogRef.afterClosed().pipe(takeUntil(this.destroycounselor$)).subscribe((result) => {
        console.log(result);
      });
    } else {
      this.dashboardService.openSnackBar("Please save Record first", "OK");
    }
  }
  // pre-op Detail PreopDetailComponent
  addPreopDetail() {
    if (this.emrService.counselorExamModel.pK_CounselorId > 0) {
      const dialogRef = this.dialog.open(PreopDetailComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "100vw !important",
        height: "100%",
        width: "100%",
        data: {
          consid: this.emrService.counselorExamModel.pK_CounselorId,
        },
      });

     dialogRef.afterClosed().pipe(takeUntil(this.destroycounselor$)).subscribe((result) => {});
    } else {
      this.dashboardService.openSnackBar("Please save Record first", "OK");
    }
  }
  // pre-ane question
  addPreAneQuestion() {
    if (this.emrService.counselorExamModel.pK_CounselorId > 0) {
      const dialogRef = this.dialog.open(PreAnaeQuestionComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "100vw !important",
        height: "100%",
        width: "100%",
        data: {
          consid: this.emrService.counselorExamModel.pK_CounselorId,
        },
      });

       dialogRef.afterClosed().pipe(takeUntil(this.destroycounselor$)).subscribe((result) => {});
    } else {
      this.dashboardService.openSnackBar("Please save Record first", "OK");
    }
  }
  iOLDetail() {
    const dialogRef = this.dialog.open(IOLComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      // height: "80%",
      width: "60%",
      data: {
        consid: this.emrService.counselorExamModel.pK_CounselorId,
      },
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroycounselor$)).subscribe((result) => {});
  }
  ngOnDestroy(){
   console.log("counselor destory");
    this.destroycounselor$.next(true);
    this.destroycounselor$.unsubscribe();
    this.helplistsergery = null;
    this.removeService = null;
    this.removePackagedetail = null;
    this.getOPTypeArray =null;
    this.opTypeName=null;
    this.opTypeId=null;
    this.rateTypelist=null;
    this.labStatus=null;
    this.counselorname=null;
    this.WardListArray=null;
    this.anesthtype=null;
    this.getOtTheatreArray = null;
    this.OTTheatreName=null;
    this.OTTheatreId=null;
    this.casetype=null;
    this.SurgeryStatus=null;
    this.DoctorListArray=null;
    this.surgeryStatusArray=null;
    this.partynameArray = null;
    this.surgerylist=null;
    this.surgeryMainArray= null;
    this.PackageListArray = null;
    this.allPackageList =null;
    this.mainSurgeronName=null;
    this.coSurgeronName=null;
    this.asstSurgeronName=null;
    this.AnaeListArray=null;
    this.bookbyname=null;
    this.AddServiceArray = null;
    this.counTrackinglist=null;
    this.aneastheticname=null;
    this.surgicalchk=null;
    this.anerTypeList=null;
    this.showPartyName=null;
    this.userId=null;
    this.modifiedName=null;
    this.bookstatus=null;
    this.lblname=null;
    this.getExamid=null;
    this.removeService = null;
    this.removePackagedetail =null;
    this.selectedSugeryArray = null;
    this.helplistsergery = null;
    this.eyetype=null;
    this.drRemarks=null;
    this.displayedColumns_surgery=null;
    this.displayedColumns_surgerybk=null;
  }
}
